<!-- App, main Vue entry point -->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  methods: {
    // Toggles header visibility based on scroll direction
    toggleHeader() {
      if (!this.$store.state.menuVisible)
        this.$store.state.headerVisible =
          document.body.getBoundingClientRect().top > this.scrollPos ||
          this.scrollPos >= 1;
      this.scrollPos = document.body.getBoundingClientRect().top;
    },
    // Adds Google Ananlytics script to head if website is on production
    addGtag() {
      if (
        !window.location.hostname.includes("localhost") &&
        !window.location.hostname.includes("dev")
      ) {
        let gtag_script = document.createElement("script");
        gtag_script.setAttribute(
          "src",
          "https://www.googletagmanager.com/gtag/js?id=UA-139124094-2"
        );
        document.head.appendChild(gtag_script);
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.toggleHeader);
  },
  created() {
    this.addGtag();
  }
};
</script>

<style>
@import "./css/animate.min.css";
@import "./css/fonts.css";
@import "./css/style.css";
@import "./css/v-tooltip.css";
</style>
